import { NewClubPay } from './NewClubPay';

export default NewClubPay;
